import React, { useEffect, useMemo } from 'react';
import SignupContentWrapper from '../components/SignupContentWrapper';
import SimpleTextFieldComponent from '../components/SimpleTextFieldComponent';
import { useTranslation } from 'react-i18next';
import { einRegExp } from '../utils/validationRegExp';
import { PATH } from '../../../routes';
import { pushEvent } from '../../../utils/clevertapUtils';
import { PAGE_EIN } from '../../../utils/clevertapEvents';
import { useRouteConfig } from '../utils/useRouteConfig';

const STEP_INFO = 2;
const validation = (value: string | undefined): boolean =>
    !!value && einRegExp.test(value);

const EinNumber: React.FC = () => {
    const { t } = useTranslation();
    const { next, previous } = useRouteConfig(PATH.SIGNUP.STEPS.SEVEN);
    const copy = useMemo(
        () => ({
            heading: t('signup.einNumber.heading'),
            subHeading: t('signup.einNumber.subHeading'),
            validationErrorText: t('signup.einNumber.errorMessage'),
            placeholderText: t('signup.einNumber.placeholderText'),
        }),
        [t],
    );
    useEffect(() => {
        pushEvent(PAGE_EIN);
    }, []);
    return (
        <SignupContentWrapper
            heading={copy.heading}
            subHeading={copy.subHeading}
            stepInfo={STEP_INFO}
            showCloseButton={true}
            backUrl={previous}
        >
            <SimpleTextFieldComponent
                type="text"
                reduxKey="ein"
                isOptional={true}
                nextLink={next || ''}
                errorText={copy.validationErrorText}
                placeholderText={copy.placeholderText}
                validation={validation}
                maxLength={10}
            />
        </SignupContentWrapper>
    );
};

export default EinNumber;
